import React, { useCallback, useEffect, useState } from "react";
import api, { formatApiError, formatTanggal, fileUrl } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import { toast } from "sonner";
import { Send, Paperclip } from "lucide-react";
import { FilterBar } from "@/components/FilterBar";

const F_EMPTY = { tanggal: "", bulan: "", tahun: "" };

export function BukuPenghubungOrtu() {
  const [all, setAll] = useState([]);
  const [reply, setReply] = useState({});
  const [filters, setFilters] = useState(F_EMPTY);
  const [applied, setApplied] = useState(F_EMPTY);
  const load = useCallback(async () => { const { data } = await api.get("/buku-penghubung"); setAll(data); }, []);
  useEffect(() => { load(); }, [load]);

  const items = all.filter((b) => {
    if (applied.tanggal && b.tanggal !== applied.tanggal) return false;
    if (applied.bulan && (b.tanggal || "").slice(5, 7) !== applied.bulan) return false;
    if (applied.tahun && (b.tanggal || "").slice(0, 4) !== String(applied.tahun)) return false;
    return true;
  });

  const balas = async (id) => {
    if (!reply[id]?.trim()) return;
    try { await api.post(`/buku-penghubung/${id}/balas`, { balasan: reply[id] }); toast.success("Balasan terkirim"); setReply({...reply, [id]: ""}); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Buku Penghubung Anak" />
      <FilterBar
        filters={filters} setFilters={setFilters}
        onApply={() => setApplied({ ...filters })}
        onReset={() => { setFilters(F_EMPTY); setApplied(F_EMPTY); }}
        dataTestidPrefix="ortu-bp-filter"
        fields={[
          { key: "tanggal", type: "tanggal", label: "Tanggal" },
          { key: "bulan", type: "bulan", label: "Bulan" },
          { key: "tahun", type: "tahun", label: "Tahun" },
        ]}
      />
      <section className="space-y-3">
        {items.length === 0 && <div className="pp-card p-10 text-center italic text-slate-400">Belum ada catatan dari guru.</div>}
        {items.map(b => (
          <article key={b.id} className="pp-card p-5">
            <div className="text-xs text-slate-500 mb-2">{formatTanggal(b.created_at)} — {b.nama_guru} → {b.nama_siswa}</div>
            <p className="text-slate-800 whitespace-pre-wrap mb-3">{b.catatan_guru}</p>
            {b.file_id && (
              <a href={fileUrl(b.file_id)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm text-indigo-600 hover:text-indigo-800 mb-3" data-testid={`ortu-bp-attachment-${b.id}`}>
                <Paperclip className="w-3.5 h-3.5" /> {b.file_name || "Lihat lampiran dari guru"}
              </a>
            )}
            {b.balasan_ortu ? (
              <div className="mt-3 p-3 bg-emerald-50 rounded-lg border border-emerald-100">
                <div className="text-[11px] uppercase tracking-wider text-emerald-700 font-semibold mb-1">Balasan Anda</div>
                <p className="text-slate-800 text-sm whitespace-pre-wrap">{b.balasan_ortu}</p>
              </div>
            ) : (
              <div className="mt-3 flex gap-2">
                <input className="pp-input flex-1" placeholder="Tulis balasan…" value={reply[b.id] || ""} onChange={(e) => setReply({...reply, [b.id]: e.target.value})} data-testid={`reply-${b.id}`} />
                <button onClick={() => balas(b.id)} className="pp-btn-primary"><Send className="w-4 h-4" />Balas</button>
              </div>
            )}
          </article>
        ))}
      </section>
    </Layout>
  );
}
